import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=23dc778a&scoped=true&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"
import style0 from "./iframe.vue?vue&type=style&index=0&id=23dc778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc778a",
  null
  
)

export default component.exports